import React from 'react';
import ServiceCard from './ServiceCard';
import web from './../../images/web.webp'
import warning from './../../images/warning.png'
import card from './../../images/cart.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const Services = () => {
    return (
        <div className='grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4'>
            {/* <ServiceCard cardTitle="" bgClass="" img={<FontAwesomeIcon icon={faCart}></FontAwesomeIcon>}> </ServiceCard> */}
            <ServiceCard cardTitle="React Application" des="I can create any type of website for your business, portfolio, company, e-commerce store, blog etc. I provide unique, clean & awesome graphical design interface." bgClass="hover:bg-gradient-to-r from-white to-secondary" img={web}> </ServiceCard>
            <ServiceCard cardTitle="Online store & shopping" des="I can create a fully functional online store with any type of payment gateway support and add shopping cart functionality into you’re existing website." bgClass="hover:bg-gradient-to-r from-white to-secondary" img={card}> </ServiceCard>
            <ServiceCard cardTitle="Fixing problems" des="Website problem & bugs it’s a common problem for every website. Don’t worry about bugs and problems. I can fix any type of problems & bugs for any website." bgClass="hover:bg-gradient-to-r from-white to-secondary" img={warning}> </ServiceCard>
        </div>
    );
};

export default Services;